import apiClient from './client';
import { telegram } from '../utils/telegram';
import { storageGet, storageRemove } from '../utils/storage';
import type { ApiResponse } from '../types/api';
import type { SessionDto, TelegramLoginResponseData } from '../types/auth';

export const authApi = {
  /**
   * Telegram auto-login using initData.
   * Returns tokens + full session (server-driven routing).
   */
  telegramLogin: async (): Promise<{ accessToken: string; refreshToken: string; session: SessionDto }> => {
    const botUsername = telegram.getBotUsername();
    const response = await apiClient.post<ApiResponse<TelegramLoginResponseData>>(
      '/public/auth/telegram-login',
      { tenantSlug: botUsername }
    );
    const data = response.data.data;
    return {
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
      session: data.session,
    };
  },

  /**
   * Get current session from server.
   * Used on app bootstrap when token already exists in storage.
   */
  getSession: async (): Promise<SessionDto> => {
    const response = await apiClient.get<ApiResponse<SessionDto>>('/v1/me/session');
    return response.data.data;
  },

  /**
   * Logout: revoke refresh token on backend, then clear local storage.
   */
  logout: async (): Promise<void> => {
    const refreshToken = await storageGet('refreshToken');
    if (refreshToken) {
      try {
        await apiClient.post('/public/auth/logout', { refreshToken });
      } catch {
        // Backend error on logout is non-critical — clear storage anyway
      }
    }
    await Promise.all([
      storageRemove('accessToken'),
      storageRemove('refreshToken'),
    ]);
  },
};
